import React, {useEffect, useState} from 'react'
import {WithTranslation, withTranslation} from 'react-i18next'
import {container} from 'src/inversify.config'
import {Icon, Select, Spin} from 'antd'
import debounce from 'lodash/debounce'
import {DataStore, Query} from '../core/stores/dataStore';
import HttpService from 'src/core/services/http.service';

export interface TenantHierarchyItem {
    order: number
    id: string
    title: string
}
export interface TenantSummary {
    id: string
    title: string
    areaName: string
    areaId: string
    hierarchyItems: TenantHierarchyItem[]
    hierarchy: string
    taxNumber: string
    viesNumber: string
    auto: boolean
    groupAlias: string,
    requiredTwoModeAuthentification: boolean
}

interface EntitySelectProps {
    excludeDescendand?: string
    addDefault?: boolean
    onChange?: (value: { value: string; label: string }) => void
    exclude?: string[]
    value?: { value: string; label: string }
    fromProfile?: boolean
    notNulleable?: boolean
    loadTenantId?: any
}

const EntitySelect: React.FC<EntitySelectProps & WithTranslation> = ({ t, onChange, exclude, value, addDefault, excludeDescendand, fromProfile, notNulleable, loadTenantId }) => {

    const httpService = container.get(HttpService);

    const [currentValue, setValue] = useState(value)
    const [loading, setLoading] = useState(false)
    const [options, setOptions] = useState<TenantSummary[]>([])

    const load = async (search: string | undefined = undefined) => {
        setLoading(true)
        var query = {
            searchQuery: search,
            orderBy: [{ field: 'title', direction: 'Ascending', useProfile: false }],
            skip: 0,
            parameters: {
                "excludeDescendand": excludeDescendand,
            },
            take: 25,
            filter: (exclude || []).length === 0 ? [] : [`id ne ${exclude?.join(' and id ne ')}`],
        } as Query

        try {
            const result = await httpService.get<any>(`${process.env.PUBLIC_URL}/api/v1/tenants/?${DataStore.buildUrl(query)}`);
            var items = result.data.items
            setOptions(items)
            if (notNulleable && items.length > 0) {
                setValue({ value: items[0].id, label: items[0].title });
                loadTenantId(items[0].id);
                if (onChange) onChange({ value: items[0].id, label: items[0].title });
            }
        } catch (error) {
            console.error("Error load data: ", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        load()
    }, []);

    const onSearch = debounce((value: string) => {
        load(value)
    }, 800)

    const onSelect = (nextValue: { value: string; label: string }) => {
        setValue(nextValue)
        onChange && onChange(nextValue)
    }

    return (
        <Select
            loading={!!loading}
            labelInValue
            placeholder={t('Select entity')}
            onChange={onSelect}
            style={{ width: '100%' }}
            allowClear={!notNulleable}
            showSearch
            value={currentValue}
            notFoundContent={!!loading ? <Spin size="small" /> : undefined}
            filterOption={false}
            showArrow={false}
            onSearch={onSearch}

        >
            {options.map((o: TenantSummary) => (
                <Select.Option key={o.id} value={o.id}>
                    <Icon type='apartment' style={{ marginRight: 5 }} />{o.title || o.title.trim().length != 0 ? o.title : t("(Empty name)")}
                </Select.Option>
            ))}
        </Select>
    )
}

export default withTranslation()(EntitySelect)
